import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { User } from '@/lib/schema/v1/user'

export const useUserStore = defineStore('user', () => {
    const user = ref<User | null>(null)

    const setUser = (staff: User | null) => {
        user.value = staff
    }

    const hasPermission = (permission?: string) => {
        if (typeof permission === 'undefined') {
            return false
        }

        if (user.value === null) {
            return false
        }

        return user.value.permissions?.findIndex((item) => item.name === permission) !== -1
    }

    const dontHavePermission = (permission: string) => {
        return !hasPermission(permission)
    }

    const hasRole = (role: string) => {
        if (user.value === null) {
            return false
        }

        return user.value.roles?.findIndex((item) => item.name === role) !== -1
    }

    const getUserLocaleKey = computed(() => user.value?.locale)

    return { user, setUser, hasPermission, dontHavePermission, hasRole, getUserLocaleKey }
})
